import "./App.css";
import { toast, ToastContainer } from "react-toastify";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.min.js";
import "../node_modules/react-toastify/dist/ReactToastify.css";
import "./global.css";
import { ConfigProvider } from "antd";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { AUTH_TOKEN, GOOGLE_CLIENT_ID, USER_SIGN_UP_DETAIL } from "./constants";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSignUpUserDetail, setUser } from "./redux/slice/auth/authSlice";
import jwt_decode from "jwt-decode";
import { fetchTeacherData } from "./redux/slice/teacherData/teacherDataThunk.js";
import router from "./routes";
import { RouterProvider } from "react-router-dom";
import WhatsAppButton from "./components/whats-app-chat-button/index.jsx";
import { Helmet } from "react-helmet-async";
import { MessagesProvider } from "./context/chat/chat-context.js";
import { NotificationProvider } from "./context/notifications/notifications-context.js";
import { clearAuthToken, isTokenExpired } from "./helper/utils.js";
import NotificationListener from "./components/NotificationListener.jsx";
import {
  initNotificationService,
  subscribeToMessages,
} from "./services/notificationService.js";

function App() {
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.auth.user);
  const token = localStorage.getItem("auth-token");
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  const createToken = () => {
    // Initialize notification service & request permission
    initNotificationService();

    // Listen for foreground messages
    subscribeToMessages((payload) => {
      // alert(`📢 New Notification: ${payload.notification?.title}`);
      const messageFrom = `${payload?.notification?.title} from ${payload?.data.senderName}`;
      toast.info(messageFrom, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        newestOnTop: false,
        closeOnClick: true,
        rtl: false,
        pauseOnFocusLoss: true,
        draggable: true,
        pauseOnHover: true,
        theme: "colored",
      });
    });
  };

  useEffect(() => {
    if (currentUser && Object.keys(currentUser).length > 0) {
      createToken();
    }
  }, [currentUser]);

  useEffect(() => {
    const unsubscribe = router.subscribe(({ location }) => {
      setCurrentPath(location.pathname);
    });
    return unsubscribe;
  }, []);

  useEffect(() => {
    const userSignUpDetail = localStorage.getItem(USER_SIGN_UP_DETAIL);

    if (token && !isTokenExpired()) {
      dispatch(setUser(jwt_decode(token)));
    } else {
      clearAuthToken();
      dispatch(setUser(null));
    }

    if (userSignUpDetail) {
      const parsed = JSON.parse(userSignUpDetail);
      dispatch(setSignUpUserDetail(parsed));
    }
  }, [dispatch, token]);

  useEffect(() => {
    if (currentUser?.role === "teacher") {
      dispatch(fetchTeacherData(currentUser));
    }
  }, [currentUser, dispatch]);

  return (
    <>
      <Helmet>
        <title>
          Tutify.online | Personalized Learning | Find Tutors Anytime, Anywhere
        </title>
        <meta
          name="description"
          content="Experience personalized learning on Tutify.online. Directly connect with expert tutors for interactive 1-on-1 lessons via chat & Zoom. Master any subject, achieve academic success."
        />
      </Helmet>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: "#01344F",
              colorBgContainer: "transparent",
            },
          }}
        >
          <MessagesProvider>
            <NotificationProvider>
              <NotificationListener currentUser={currentUser} />
              <RouterProvider router={router} />
              {currentPath === "/" && <WhatsAppButton />}
            </NotificationProvider>
          </MessagesProvider>
        </ConfigProvider>
      </GoogleOAuthProvider>
      <ToastContainer
        style={{ width: "400px" }}
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </>
  );
}

export default App;
